enum GesCloudOrgSettingsPage {
	ORGANIZATION = "organization",
	MEMBERS = "members",
}

export default GesCloudOrgSettingsPage;
